import React, { FC } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { ActionButton, ActionButtonSizes, ActionButtonVariants } from 'components/action-button';

export interface IItemActionsProps {
  showEdit?: boolean;
  onEdit: VoidFunction;
  onRemove: VoidFunction;
}

const Layout = styled.div`
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: start;
  button {
    margin-inline-end: 1rem;
  }
`;

export const ItemActions: FC<IItemActionsProps> = ({ showEdit = true, onEdit, onRemove }) => {
  const { formatMessage } = useIntl();
  return (
    <Layout data-testid="item-actions">
      {showEdit && (
        <ActionButton
          aria-label={formatMessage({ id: 'edit' })}
          data-testid="edit-item-action"
          color="primary"
          variant={ActionButtonVariants.TEXT_ONLY}
          size={ActionButtonSizes.SMALL}
          onClick={onEdit}
        >
          {formatMessage({ id: 'edit' })}
        </ActionButton>
      )}
      <ActionButton
        aria-label={formatMessage({ id: 'remove' })}
        data-testid="remove-item-action"
        color="primary"
        variant={ActionButtonVariants.TEXT_ONLY}
        size={ActionButtonSizes.SMALL}
        onClick={onRemove}
      >
        {formatMessage({ id: 'remove' })}
      </ActionButton>
    </Layout>
  );
};
